import { tv } from "tailwind-variants";

export const badge = tv({
    base: [
        "tw:inline-block tw:rounded-full tw:p-0 tw:text-xs tw:text-center tw:align-baseline tw:whitespace-nowrap tw:font-bold tw:leading-6 tw:w-6"
    ],

    variants: {
        size: {
            sm: "tw:leading-5 tw:w-5",
            md: "tw:leading-6 tw:w-6"
        },
        inverse: {
            true: "tw:bg-background tw:text-primary",
            false: "tw:bg-primary tw:text-white"
        }
    },
    defaultVariants: {
        inverse: false,
        size: "md"
    }
});
